<template>
  <div id="projectdashboard">
    <div v-if="errored" >
      <b-alert show variant="danger">An error occurred loading data.</b-alert>
      <p>{{ error }}</p>
      <p class="text-center">
        <b-button type="button" @click="reload">Retry</b-button>
      </p>
    </div>

    <div v-if="loading&&!errored">
      <b-alert show class="text-center">
        Loading {{ this.$route.params.id }}...
        <b-spinner></b-spinner>
      </b-alert>
    </div>

    <div v-if="!loading">
      <div v-if="data">
        
      <b-card header-tag="header" bg-variant="light">
        <h4 slot="header">{{ data.project.projectId }} {{ data.project.description }}</h4>

        <div class="d-flex flex-wrap">

          <!-- module buttons -->
        <b-list-group-item v-if="modules.includes('journal')" 
          class="mx-1" style="width:220px;" :button=true v-on:click.stop="journal()">  
          <img style="padding-right:10px" src="../assets/images/journal-icon.svg"  height="42px"> <b> Site Journal </b> 
        </b-list-group-item>
        <b-list-group-item v-else 
          class="mx-1" style="width:220px;" :button=true disabled>  
          <img style="padding-right:10px" src="../assets/images/journal-icon-disabled.svg"  height="42px"> Site Journal 
        </b-list-group-item>

        <b-list-group-item v-if="modules.includes('poviewer')" 
          class="mx-1  border-top" style="width:220px;" :button=true :disabled="true" v-on:click.stop="purchaseOrders()">  
          <img style="padding-right:10px" src="../assets/images/poviewer-icon.svg"  height="46px"> <b>PO Viewer </b> 
        </b-list-group-item>
        <b-list-group-item v-else 
          class="mx-1  border-top" style="width:220px;" :button=true disabled>  
          <img style="padding-right:10px" src="../assets/images/poviewer-icon-disabled.svg"  height="46px"> PO Viewer 
        </b-list-group-item>        

        <b-list-group-item v-if="modules.includes('issuelog')" 
          class="mx-1" style="width:220px;" :button=true v-on:click.stop="issuelog()">  
          <img style="padding-right:10px" src="../assets/images/issuelog-icon.svg"  height="46px"> <b> Issue Log </b> 
        </b-list-group-item>
        <b-list-group-item v-else 
          class="mx-1" style="width:220px;" :button=true disabled>  
          <img style="padding-right:10px" src="../assets/images/issuelog-icon-disabled.svg"  height="46px"> Issue Log 
        </b-list-group-item>

        <b-list-group-item v-if="modules.includes('photos')" 
          class="mx-1" style="width:220px;" :button=true v-on:click.stop="projectPhotos()">  
          <img style="padding-right:10px" src="../assets/images/photos-icon.svg"  height="46px"> <b> Photos </b> 
        </b-list-group-item>
        <b-list-group-item v-else 
          class="mx-1" style="width:220px;" :button=true disabled>  
          <img style="padding-right:10px" src="../assets/images/photos-icon-disabled.svg"  height="46px"> Photos 
        </b-list-group-item>

        <!-- <b-list-group-item v-if="modules.includes('timeentry')" 
          class="mx-1" style="width:220px;" :button=true v-on:click.stop="timeEntry()">  
          <img style="padding-right:10px" src="../assets/images/timeentry-icon.svg"  height="42px"> <b> Time Entry </b> 
        </b-list-group-item>
        <b-list-group-item v-else 
          class="mx-1" style="width:220px;" :button=true disabled>  
          <img style="padding-right:10px" src="../assets/images/timeentry-icon-disabled.svg"  height="42px"> Time Entry 
        </b-list-group-item>

        <b-list-group-item v-if="modules.includes('production')" 
          class="mx-1" style="width:220px;" :button=true v-on:click.stop="productionEntry()">  
          <img style="padding-right:10px" src="../assets/images/production-icon.svg"  height="42px"> <b> Production </b> 
        </b-list-group-item>
        <b-list-group-item v-else 
          class="mx-1" style="width:220px;" :button=true disabled>  
          <img style="padding-right:10px" src="../assets/images/production-icon-disabled.svg"  height="42px"> Production 
        </b-list-group-item> -->

        <b-list-group-item v-if="isAdmin||state.isSysAdmin" 
          class="mx-1" style="width:220px;" :button=true v-on:click.stop="projectUsers()">   
          <img style="padding-right:5px" src="../assets/images/useradmin-icon.svg"  height="42px"> <b> Project Users </b>  
        </b-list-group-item>
  
        </div>

      </b-card>

    </div>

  </div>

</div>

</template>

<script>
export default {
  name: "Project",
  data: function() {
    return {
      data: null,
      projectId: this.$route.params.id,
      isAdmin: false,
      modules: [],
      state: this.$store.state,
      loading: true,
      errored: false,
      error: ""
    };
  },

  activated: function() {
    //console.log("activated!");
    this.setProject();
    this.setBreadcrumb();
  },
  mounted: function() {
    this.fetchData();
  },

  methods: {
    updateMru() {
      this.$auth.acquireToken().then(token => {
        this.$http
          .post("api/Mru/" + this.projectId, null, {
            headers: { Authorization: "Bearer " + token }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    fetchData() {
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/Project/" + this.projectId, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.data = response.data;   //[0];  
            if (response.status == 204) {
              this.errored = true;
              this.loading = false;
              this.error =
                "Project " + this.projectId + ": Not found/No user access  ";
            } else {
             this.$store.setItem("project", this.data.project.projectId + ' ' + this.data.project.description);
             this.$store.setItem("projectId", this.data.project.projectId);
             //this.setModules();
             this.modules = this.data.modules;
             this.setProject();
             this.setIsAdmin();
             this.updateMru();
            };

          })
          .catch(error => {
            console.log(error);
            this.errored = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.loading = false));
      });
    },

    //  setModules() {
    //   this.$auth.acquireToken().then(token => {
    //     this.$http
    //       .get("api/UserModules/" + this.data.projectId , {
    //         headers: { Authorization: "Bearer " + token }
    //       })
    //       .then(response => {
    //         this.modules = response.data;
    //       })
    //       .catch(error => {
    //         console.log(error);
    //       });
    //   });
    // },

     setIsAdmin() {
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/IsAdmin/" + this.data.project.branchId , {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.isAdmin = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    purchaseOrders() {
      this.$router.push({
        name: "PurchaseOrders",
        params: { id: this.data.project.projectId }
      });
    },

     journal() {
      this.$router.push({
        name: "Journal",
        params: { id: this.data.project.projectId }
      });
    },

     issuelog() {
      this.$router.push({
        name: "Issues",
        params: { id: this.data.project.projectId }
      });
    },

     projectPhotos() {
      this.$router.push({
        name: "ProjectPhotos",
        params: { id: this.data.project.projectId }
      });
    },    

    timeEntry() {

    },

    productionEntry() {

    },

    projectUsers() {
      this.$router.push({
        name: "ProjectUsers",
        params: { id: this.data.project.projectId }
      });
    },    

    setProject() {
      if (this.data){
      this.$store.setItem("projectId", this.data.project.projectId);
      this.$store.setItem("project", this.data.project.projectId + ' ' + this.data.project.description);
      this.$store.setItem("modules", this.data.modules);
      }

    },

    setBreadcrumb() {
      this.$store.setItem("breadcrumbs", []);
    },

    reload() {
      this.$router.go(0);
    }
  }
};
</script>

<style>

.list-group-item.disabled img,
.list-group-item:disabled img {
  filter: grayscale(100%) opacity(50%);
}

.list-group-item.disabled {
  opacity: 0.7;
}


#projectdashboard {
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
  padding-top: 5px;
}
</style>